import React from "react";
import { Badge, Button } from "reactstrap";
import { MdInsertChart } from "react-icons/md";
import Player from "../../components/Player";

const SingleRow = props => {
  const { active, type, id, name, value, formatter, onDetails, showDetailsButton, ...rest } = props;
  return (
    <div
      {...rest}
    >
      <span className="text-truncate" dir="ltr" title={name}>{name}</span>
      <div className="mr-auto d-flex align-items-center">
        <Badge pill dir="ltr">
          {typeof formatter === 'function' ? formatter(value) : value}
        </Badge>
        {type === 'track' && active &&
          <Player trackId={id}  />
        }
        {showDetailsButton && active &&
          <Button className="has-icon p-0 mr-2" color="link" size="sm" onClick={() => onDetails({ type, name, id })}>
            <MdInsertChart />
          </Button>
        }
      </div>
    </div>
  )
}

export default SingleRow;